export default __webpack_public_path__ + "static/media/vid9.1c73fe1c.mp4";